<template>
  <div class="ticker-card">
    <div class="ticker-card-header">
      <div class="ticker-card-header-teams">
        <span v-if="tickerBet.eventName">{{tickerBet.eventName}} | {{$t(`sports.${tickerBet.sportIdentifier}`)}}</span>
        <span v-else>{{tickerBet.homeTeam}} &ndash; {{tickerBet.awayTeam}} | {{$t(`sports.${tickerBet.sportIdentifier}`)}}</span>
      </div>
      <div class="ticker-card-header-timestamp">
        <span>{{tickerBet.timeStamp.substring(11)}}</span>
      </div>
    </div>
    <div class="ticker-card-content">
      <div class="ticker-card-users">
        <div class="ticker-card-user-back ticker-card-user">
          <span><span class="ticker-card-inner-title">{{$t(`trader.ticker.back`)}}</span>{{tickerBet.backUser}} {{tickerBet.backFromBot?'(BOT)':''}}</span>
        </div>
        <div class="ticker-card-user-lay ticker-card-user">
          <span><span class="ticker-card-inner-title">{{$t(`trader.ticker.lay`)}}</span>{{tickerBet.layUser}} {{tickerBet.layFromBot?'(BOT)':''}}</span>
        </div>
      </div>
      <div class="ticker-card-result">
        <span class="ticker-card-result-text"><span class="ticker-card-inner-title">{{tickerBet.market | capitalise}}</span>{{tickerBet.runner | capitalise}}</span>
      </div>
      <div class="ticker-card-cells">
        <div class="ticker-card-cell ticker-card-odds-cell">
          <div class="ticker-card-cell-title">
            <span>{{$t(`trader.ticker.odds`) | removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="ticker-card-cell-content">
            <span>{{tickerBet.odds}}</span>
          </div>
        </div>
        <div class="ticker-card-cell ticker-card-stake-cell">
          <div class="ticker-card-cell-title">
            <span>{{$t(`trader.ticker.stake`) | removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="ticker-card-cell-content">
            <span>{{tickerBet.stakeUSD | numberWithCommasAndCurrency(this.userCurrency)}}</span>
          </div>
        </div>
        <div class="ticker-card-cell ticker-card-profit-liability-cell">
          <div class="ticker-card-cell-title">
            <span><span class="ticker-card-cell-title-profit">{{$t(`trader.ticker.profit`) | removeDiacriticsFromUppercase}}</span> | <span class="ticker-card-cell-title-liability">{{$t(`trader.ticker.liability`) | removeDiacriticsFromUppercase}}</span></span>
          </div>
          <div class="ticker-card-cell-content">
            <span>{{tickerBet.profitLiabilityUSD | numberWithCommasAndCurrency(this.userCurrency)}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "tickerCard",
  props:['tickerBet'],
  computed:{
    userCurrency: function () {
      return this.$store.state.userCurrency;
    },
  },
  data:function () {
    return {
      animate: true
    };
  },
  methods:{}
}
</script>

<style scoped>
  .ticker-card{
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19) !important;
    width: 100%;
    position: relative;
    transform: translateY(0);
  }

  .ticker-card-animation{
    animation: slide 0.6s ease-in-out;
  }

  .ticker-card-header{
    display: flex;
    align-items: center;
    background-color: var(--grey-400);
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
  }

  .ticker-card-header-teams{
    display: flex;
    align-items: center;
    margin-right: auto;
  }

  .ticker-card-header-teams > span{
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: white;
    padding: 8px;
  }

  .ticker-card-header-timestamp{
    display: flex;
    align-items: center;
  }

  .ticker-card-header-timestamp > span{
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: white;
    padding: 8px;
  }

  .ticker-card-content{
    display: flex;
    flex-direction: column;
    padding: 8px;
  }

  .ticker-card-users{
    display: flex;
    padding-bottom: 4px;
  }

  .ticker-card-user{
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    width: 100%;
    max-width: 50%;
    overflow: hidden;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ticker-card-user-back{
    margin-right: 8px;
    color: var(--superman);
  }

  .ticker-card-user-lay{
    color: var(--lex-luthor);
  }

  .ticker-card-inner-title{
    font-size: 12px;
    line-height: 16px;
    font-weight: normal;
    color: var(--grey-500);
    padding-right: 8px;
  }

  .ticker-card-user .ticker-card-inner-title {
    padding-right: 4px;
  }

  .ticker-card-result .ticker-card-inner-title {
    font-size: 14px;
    line-height: 19px;
  }

  .ticker-card-result{
    display: flex;
    padding-bottom: 8px;
  }

  .ticker-card-result-text{
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    color: var(--grey-900);
    overflow: hidden;
    text-overflow: ellipsis;
    /* We want it to wrap because runners can have long names
    white-space: nowrap; */
  }

  .ticker-card-cells{
    display: flex;
  }

  .ticker-card-cell{
    display: flex;
    flex-direction: column;
    margin-right: 8px;
  }

  .ticker-card-odds-cell{
    min-width: 80px;
    max-width: 80px;
  }

  .ticker-card-stake-cell{
    min-width: 90px;
    max-width: 90px;
  }

  .ticker-card-profit-liability-cell{
    margin-right: unset;
    width: 100%;
    min-width: 0 !important;
    max-width: calc(100% - 142px) !important;
  }

  .ticker-card-cell-title{
    display: flex;
    align-items: center;
    padding-bottom: 1px;
  }

  .ticker-card-cell-title > span{
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    color: var(--grey-600);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: uppercase;
  }

  .ticker-card-cell-content{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--grey-100);
    border-radius: 6px;
    overflow: hidden;
  }

  .ticker-card-cell-content > span{
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: var(--grey-900);
    padding: 6px 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ticker-card-cell-title-profit{
    color: var(--superman);
    padding-right: 2px;
  }

  .ticker-card-cell-title-liability{
    color: var(--lex-luthor);
    padding-left: 2px;
  }

  @keyframes slide {
    0% { transform: translateY(-154px);}
    100% { transform: translateY(0px);}
  }

</style>
